import React from "react";
import "../../css/PrimarySchoolSection.css";
import { Link } from "react-router-dom";
import SchoolHero from "./SchoolHero";
import ParentTestimonials from "../ParentTestimonials";
import WhyChooseUs from "../WhyChooseUs";

const PrimarySchoolSection = () => {
  const primaryImg = "./images/f.jpeg";

  return (
    <>
      <SchoolHero
        title="Primary School"
        subtitle="Building strong foundations for lifelong learning."
        image="/images/m.jpeg"
      />
      <section className="primary-school-container">
        <div className="ps-main-card">
          <div className="ps-flex-layout">
            {}
            <div className="ps-image-box">
              <img
                src={primaryImg}
                alt="Primary School Students"
                className="ps-hero-img"
              />
            </div>

            {}
            <div className="ps-info-box">
              <div className="ps-green-header">
                <h2>Primary School (Grades 1-5)</h2>
              </div>

              <div className="ps-content-body">
                <div className="ps-meta">
                  <span className="ps-grade">
                    <strong>Grade:</strong> Grades 1-5
                  </span>
                  <span className="ps-status">
                    {" "}
                    <i className="ps-check">✔</i> Enrolling Now
                  </span>
                </div>

                <p className="ps-desc-text">
                  During primary school years, we support the holistic
                  development of students while empowering them to take
                  increased ownership of their learning. Our transdisciplinary
                  approach encourages students to apply what they are learning
                  across subject areas within the school, the local community
                  and the world. We incorporate students' interests into the
                  curriculum and provide opportunities for them to showcase
                  their talents. Through service projects and field trips, we
                  encourage our children to become engaged in the local
                  community and the world at large.
                </p>
              </div>

              {}
              <div className="ps-bottom-nav">
                <div className="ps-nav-item">
                  <Link to="/book-meeting">🤝 BOOK A MEETING</Link>
                </div>

                <div className="ps-nav-item">
                  <Link to="/admissionenquiryform">📄 ADMISSION FORM</Link>
                </div>

                <div className="ps-nav-item">
                  <Link to="/feestructure">💵 FEES</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ParentTestimonials />
      <WhyChooseUs />
    </>
  );
};

export default PrimarySchoolSection;
